/* Pure Living Weihnachtsbäume – Verhalten. Ohne Abhängigkeiten. */
(function () {
  'use strict';
  var I18N = {}; try { var i18nEl = document.getElementById('pl-i18n'); if (i18nEl) { I18N = JSON.parse(i18nEl.textContent) || {}; } } catch (e) { I18N = {}; }
  function T(k, de) { return Object.prototype.hasOwnProperty.call(I18N, k) ? I18N[k] : de; }
  var de = new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' });
  function geld(cent) { return de.format((cent || 0) / 100); }
  function $(s, r) { return (r || document).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }
  function meter(cm) { return (cm / 100).toFixed(2).replace('.', ',') + ' m'; }
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var ruhig = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- Schleier, Menü ---------- */
  var schleier = $('[data-schleier]');
  var offen = null;
  function schleierAn(fn) { if (!schleier) return; schleier.hidden = false; requestAnimationFrame(function () { schleier.dataset.offen = 'true'; }); offen = fn; }
  function schleierAus() { if (!schleier) return; schleier.dataset.offen = 'false'; setTimeout(function () { schleier.hidden = true; }, 260); offen = null; }
  if (schleier) schleier.addEventListener('click', function () { if (offen) offen(); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && offen) offen(); });

  var kopf = $('[data-kopf]');
  // Höhe der klebenden Kopfzeile als CSS-Variable (für Galerie und Sprungmarken)
  if (kopf) { var kh = function () { document.documentElement.style.setProperty('--kopf-hoehe', Math.round(kopf.getBoundingClientRect().height) + 'px'); }; kh(); window.addEventListener('resize', kh); if ('ResizeObserver' in window) new ResizeObserver(kh).observe(kopf); }
  if (kopf) {
    var auf = $('[data-menue-auf]', kopf), zu = $('[data-menue-zu]', kopf);
    var menueZu = function () { kopf.dataset.menue = ''; auf.setAttribute('aria-expanded', 'false'); schleierAus(); auf.focus(); };
    auf && auf.addEventListener('click', function () { kopf.dataset.menue = 'offen'; auf.setAttribute('aria-expanded', 'true'); schleierAn(menueZu); var l = $('.pl-kopf__nav a', kopf); l && l.focus(); });
    zu && zu.addEventListener('click', menueZu);
  }

  /* ---------- Warenkorb ---------- */
  var korb = $('[data-korb]');
  var Korb = {
    freigrenze: korb ? parseInt(korb.dataset.freigrenze || '0', 10) : 0,
    laden: function () { return fetch(root + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }); },
    hinzu: function (id, menge) {
      return fetch(root + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: id, quantity: menge || 1 }] }) })
        .then(function (r) { return r.json().then(function (d) { if (!r.ok) throw new Error(d.description || d.message || T('fehler', 'Fehler')); return d; }); });
    },
    aendern: function (key, menge) {
      return fetch(root + 'cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: key, quantity: menge }) }).then(function (r) { return r.json(); });
    },
    zahl: function (n) { $$('[data-korb-zahl]').forEach(function (el) { el.textContent = n; el.dataset.leer = n ? 'false' : 'true'; }); $$('[data-korb-auf]').forEach(function (a) { a.setAttribute('aria-label', T('korb_aria_vor', 'Warenkorb, ') + n + T('korb_aria_nach', ' Artikel')); }); },
    zeichnen: function (c) {
      if (!korb) return;
      Korb.zahl(c.item_count);
      var liste = $('[data-korb-liste]', korb), fuss = $('[data-korb-fuss]', korb), vers = $('[data-korb-versand]', korb);
      liste.innerHTML = '';
      if (!c.item_count) {
        liste.innerHTML = '<li class="pl-korb__leer"><p>' + T('korb_leer', 'Ihr Warenkorb ist leer.') + '</p><a class="pl-knopf pl-knopf--ruhig" href="' + root + 'collections/weihnachtsbaeume">' + T('baeume_ansehen', 'Weihnachtsbäume ansehen') + '</a></li>';
        fuss.hidden = true; vers.hidden = true; return;
      }
      fuss.hidden = false; vers.hidden = !Korb.freigrenze;
      if (Korb.freigrenze) {
        var rest = Korb.freigrenze - c.total_price;
        $('[data-korb-versand-text]', korb).innerHTML = rest > 0 ? 'Noch <strong>' + geld(rest) + '</strong> bis zum kostenlosen Versand.' : '<strong>Kostenloser Versand</strong> ist erreicht.';
        $('[data-korb-fortschritt]', korb).style.width = Math.min(100, Math.round(c.total_price / Korb.freigrenze * 100)) + '%';
      }
      c.items.forEach(function (it) {
        var li = document.createElement('li'); li.className = 'pl-posten';
        var bild = it.image ? it.image.replace(/(\.[a-z]+)(\?|$)/i, '$1$2') : '';
        li.innerHTML = '<img alt="" loading="lazy" width="76" height="95" src="' + (bild ? bild + (bild.indexOf('?') > -1 ? '&' : '?') + 'width=180' : '') + '">' +
          '<div><div class="pl-posten__name"></div><div class="pl-posten__var"></div>' +
          '<div class="pl-zaehler" role="group" aria-label="' + T('menge', 'Menge') + '"><button type="button" data-minus aria-label="' + T('eins_weniger', 'Eins weniger') + '">−</button><input type="number" min="0" inputmode="numeric" aria-label="' + T('menge', 'Menge') + '" value="' + it.quantity + '"><button type="button" data-plus aria-label="' + T('eins_mehr', 'Eins mehr') + '">+</button></div>' +
          '<button type="button" class="pl-posten__weg" data-weg>' + T('entfernen', 'Entfernen') + '</button></div>' +
          '<div class="pl-posten__preis">' + geld(it.final_line_price) + '</div>';
        $('.pl-posten__name', li).textContent = it.product_title;
        $('.pl-posten__var', li).textContent = it.variant_title || '';
        var inp = $('input', li);
        var setz = function (n) { korb.dataset.laedt = 'true'; Korb.aendern(it.key, Math.max(0, n)).then(function (d) { korb.dataset.laedt = 'false'; Korb.zeichnen(d); }); };
        $('[data-minus]', li).addEventListener('click', function () { setz(it.quantity - 1); });
        $('[data-plus]', li).addEventListener('click', function () { setz(it.quantity + 1); });
        $('[data-weg]', li).addEventListener('click', function () { setz(0); });
        inp.addEventListener('change', function () { setz(parseInt(inp.value || '0', 10)); });
        liste.appendChild(li);
      });
      $('[data-korb-summe]', korb).textContent = geld(c.total_price);
      var dz = $('[data-korb-dazu]', korb); if (dz) Korb.dazu(c, dz, false);
    },
    /* Vorschläge: Baum im Korb -> Kränze und Girlanden, nur Kränze/Girlanden -> Bäume. Nie, was schon im Korb liegt. */
    angebote: (function () { var el = $('[data-korb-angebote]'); try { return el ? JSON.parse(el.textContent) : []; } catch (e) { return []; } })(),
    dazu: function (c, box, seite) {
      var drin = (c.items || []).map(function (it) { return it.handle; });
      var hat = function (art) { return Korb.angebote.some(function (a) { return a.art === art && drin.indexOf(a.handle) > -1; }); };
      var ziel = hat('baum') ? 'deko' : (hat('deko') ? 'baum' : null);
      var liste = ziel ? Korb.angebote.filter(function (a) { return a.art === ziel && drin.indexOf(a.handle) < 0; }) : [];
      box.innerHTML = ''; box.hidden = !liste.length; box.dataset.ziel = ziel || '';
      if (!liste.length) return;
      var h = document.createElement('p'); h.className = 'pl-dazu__titel'; h.textContent = ziel === 'deko' ? T('passend_baum', 'Passend zum Baum') : T('dazu_baum', 'Dazu der passende Baum'); box.appendChild(h);
      liste.forEach(function (a) {
        var std = a.varianten.filter(function (v) { return v.id === a.std; })[0] || a.varianten[0];
        var k = document.createElement('div'); k.className = 'pl-dazu'; k.dataset.handle = a.handle;
        var opts = a.varianten.map(function (v) { return '<option value="' + v.id + '"' + (v.id === std.id ? ' selected' : '') + (v.da ? '' : ' disabled') + '>' + v.titel.replace(/</g, '').replace(' / Ohne Beleuchtung', ', ohne Licht').replace(' / Mit LED-Beleuchtung', ', mit LED') + ' · ' + geld(v.preis) + (v.da ? '' : T('ausverkauft_klammer', ' (ausverkauft)')) + '</option>'; }).join('');
        var sid = 'pl-dazu-' + a.handle + (seite ? '-s' : '');
        k.innerHTML = '<a class="pl-dazu__bild" href="' + a.url + '" tabindex="-1"><img alt="" loading="lazy" width="72" height="90" src="' + (std.bild || a.bild || '') + '"></a>' +
          '<div class="pl-dazu__text"><a class="pl-dazu__name" href="' + a.url + '"></a><span class="pl-dazu__ab">' + T('ab', 'ab ') + geld(Math.min.apply(null, a.varianten.filter(function (v) { return v.da; }).map(function (v) { return v.preis; }))) + '</span>' +
          '<label class="pl-hinweis-leser" for="' + sid + '">' + T('ausfuehrung_waehlen', 'Ausführung wählen') + '</label><select id="' + sid + '" class="pl-dazu__wahl">' + opts + '</select></div>' +
          '<button type="button" class="pl-dazu__knopf" data-dazu-hinzu>' + T('hinzufuegen', 'Hinzufügen') + '</button>';
        $('.pl-dazu__name', k).textContent = a.name;
        var sel = $('select', k), img = $('img', k);
        sel.addEventListener('change', function () { var v = a.varianten.filter(function (x) { return String(x.id) === sel.value; })[0]; if (v && v.bild) img.src = v.bild; });
        $('[data-dazu-hinzu]', k).addEventListener('click', function () {
          var bt = this; bt.disabled = true; bt.textContent = T('wird_hinzugefuegt', 'Wird hinzugefügt …');
          Korb.hinzu(parseInt(sel.value, 10), 1).then(function () {
            if (seite) { location.reload(); return; }
            return Korb.laden().then(Korb.zeichnen);
          }).catch(function (err) { bt.disabled = false; bt.textContent = T('hinzufuegen', 'Hinzufügen'); alert(T('fehler_text', 'Das hat nicht geklappt: ') + err.message); });
        });
        box.appendChild(k);
      });
    },
    oeffnen: function () {
      if (!korb) return;
      korb.hidden = false;
      requestAnimationFrame(function () { korb.dataset.offen = 'true'; });
      schleierAn(Korb.schliessen);
      var z = $('[data-korb-zu]', korb); z && z.focus();
    },
    schliessen: function () { if (!korb) return; korb.dataset.offen = 'false'; schleierAus(); setTimeout(function () { korb.hidden = true; }, 330); }
  };
  window.plKorb = Korb;
  (function () { var s = $('[data-korb-dazu-seite]'); if (s) Korb.laden().then(function (c) { Korb.dazu(c, s, true); }); })();
  /* Kundenstimmen: weitere anzeigen (je Klick ein Schritt, Knopf verschwindet, wenn alle sichtbar sind) */
  $$('[data-stimmen-mehr]').forEach(function (bt) {
    bt.addEventListener('click', function () {
      var sek = bt.closest('section'), schritt = parseInt(bt.getAttribute('data-schritt') || '12', 10);
      var neu = $$('[data-stimme-mehr][hidden]', sek).slice(0, schritt);
      neu.forEach(function (f) { f.hidden = false; });
      var rest = $$('[data-stimme-mehr][hidden]', sek).length;
      bt.setAttribute('aria-expanded', rest ? 'false' : 'true');
      if (!rest) bt.parentNode.hidden = true;
      if (neu[0]) { neu[0].setAttribute('tabindex', '-1'); neu[0].focus({ preventScroll: true }); }
    });
  });
  /* Fotostreifen der Kundenstimmen: endlos blättern (Runde 8). Am Ende geht es mit dem ersten Bild weiter, am Anfang rückwärts zum letzten.
     Pfeile, Pfeiltasten (Fokus auf dem Streifen) und Wischen über den Rand hinaus. */
  $$('[data-stimmen-fotos]').forEach(function (st) {
    var sek = st.closest('section');
    var art = ruhig ? 'auto' : 'smooth';
    var schritt = function () { var k = st.querySelector('.pl-stimme'); if (!k) return st.clientWidth; var g = parseFloat(getComputedStyle(st).columnGap) || 0; return k.getBoundingClientRect().width + g; };
    var seite = function () { return schritt() * Math.max(1, Math.floor((st.clientWidth + 2) / schritt())); };
    var maxL = function () { return Math.max(0, st.scrollWidth - st.clientWidth); };
    var amEnde = function () { return st.scrollLeft >= maxL() - 4; };
    var amAnfang = function () { return st.scrollLeft <= 4; };
    function gehe(r) {
      if (r > 0 && amEnde()) st.scrollTo({ left: 0, behavior: art });
      else if (r < 0 && amAnfang()) st.scrollTo({ left: maxL(), behavior: art });
      else st.scrollBy({ left: r * seite(), behavior: art });
    }
    st.plGehe = gehe;
    var zu = $('[data-fotos-zurueck]', sek), vor = $('[data-fotos-vor]', sek);
    if (zu) zu.addEventListener('click', function () { gehe(-1); });
    if (vor) vor.addEventListener('click', function () { gehe(1); });
    st.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { e.preventDefault(); gehe(1); }
      else if (e.key === 'ArrowLeft') { e.preventDefault(); gehe(-1); }
    });
    var x0 = null, warEnde = false, warAnfang = false;
    st.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; warEnde = amEnde(); warAnfang = amAnfang(); }, { passive: true });
    st.addEventListener('touchend', function (e) {
      if (x0 === null) return; var dx = e.changedTouches[0].clientX - x0; x0 = null;
      if (dx < -40 && warEnde && amEnde()) gehe(1);
      else if (dx > 40 && warAnfang && amAnfang()) gehe(-1);
    }, { passive: true });
  });
  /* Aufbauvideo: Teil 1 / Teil 2 umschalten, das andere Video anhalten */
  $$('[data-videos]').forEach(function (box) {
    $$('[data-video-teil]', box).forEach(function (bt) {
      bt.addEventListener('click', function () {
        var n = bt.getAttribute('data-video-teil');
        $$('[data-video]', box).forEach(function (f) { var an = f.getAttribute('data-video') === n; var v = $('video', f); if (!an && v && !v.paused) v.pause(); f.hidden = !an; });
        $$('[data-video-teil]', box).forEach(function (x) { x.setAttribute('aria-pressed', x === bt ? 'true' : 'false'); });
      });
    });
  });
  if (korb) {
    $$('[data-korb-auf]').forEach(function (a) { a.addEventListener('click', function (e) { e.preventDefault(); Korb.laden().then(Korb.zeichnen); Korb.oeffnen(); }); });
    $('[data-korb-zu]', korb).addEventListener('click', Korb.schliessen);
  }

  /* ---------- Bühne (Größenberater) ---------- */
  $$('[data-buehne]').forEach(function (b) {
    var daten; try { daten = JSON.parse($('[data-buehne-daten]', b).textContent); } catch (e) { return; }
    var regler = $('[data-decke]', b), wert = $('[data-decke-wert]', b), satz = $('[data-satz]', b), ziel = $('[data-ziel]', b);
    var podium = $('[data-podium]', b), schalter = $('[data-licht-schalter]', b);
    var bA = $('[data-p-bild="a"]', b), bB = $('[data-p-bild="b"]', b), aktiv = bA;
    var st = { decke: parseInt(regler.value, 10), linie: 0, licht: false };
    var hoehen = daten[0].varianten.map(function (v) { return v.cm; }).filter(function (v, i, a) { return a.indexOf(v) === i; }).sort(function (a, b) { return a - b; });
    var LUFT = 20, OBEN = 340;
    function empfehlung() { var max = st.decke - LUFT, r = null; hoehen.forEach(function (h) { if (h <= max) r = h; }); return r || hoehen[0]; }
    function variante(l, cm, licht) { return daten[l].varianten.filter(function (v) { return v.cm === cm && v.licht === licht; })[0]; }
    function bildZeigen(url, alt) {
      if (!url) return;
      if (aktiv.getAttribute('src') === url) { aktiv.alt = alt; return; }
      var neu = aktiv === bA ? bB : bA;
      neu.onload = function () { neu.alt = alt; aktiv.alt = ''; neu.dataset.sichtbar = 'true'; aktiv.dataset.sichtbar = 'false'; aktiv = neu; };
      neu.src = url;
    }
    function zeichnen() {
      var cm = empfehlung(), v = variante(st.linie, cm, st.licht);
      wert.innerHTML = (st.decke / 100).toFixed(2).replace('.', ',') + '<small>m</small>';
      regler.style.setProperty('--anteil', ((st.decke - 200) / 120 * 100) + '%');
      var platz = st.decke - LUFT;
      satz.innerHTML = 'Bei ' + meter(st.decke) + ' Raumhöhe ist Platz für einen Baum bis ' + platz + ' cm. Wir empfehlen <strong>' + cm + ' cm</strong>' + (cm === hoehen[hoehen.length - 1] && platz > cm + 15 ? ', unseren größten Baum.' : '.');
      [0, 1].forEach(function (l) {
        var x = variante(l, cm, st.licht), el = $('[data-preis="' + l + '"]', b);
        if (x && el) el.innerHTML = geld(x.preis) + (x.uvp > x.preis ? T('s_uvp', '<s>UVP ') + geld(x.uvp) + '</s>' : '');
      });
      if (v) { ziel.href = v.url; ziel.textContent = 'Zum ' + daten[st.linie].name.replace('Weihnachtsbaum ', '') + ' · ' + cm + ' cm'; }
      // Maßstab
      var H = podium.clientHeight, boden = Math.round(H * 0.08), px = (H - boden - 18) / OBEN;
      podium.style.setProperty('--boden', boden + 'px');
      var W = podium.clientWidth, baumX = Math.round(W * 0.6), menschX = Math.round(W * 0.2);
      var deckeY = boden + st.decke * px;
      var d = $('[data-p-decke]', b); d.style.bottom = deckeY + 'px';
      $('[data-p-decke-text]', b).textContent = 'Ihre Decke · ' + meter(st.decke);
      var m = $('[data-p-mensch]', b); m.style.height = Math.round(175 * px) + 'px'; m.style.bottom = boden + 'px'; m.style.left = Math.round(menschX - (175 * px * 554 / 1684) / 2) + 'px';
      var bh = Math.round(cm * px), baum = $('[data-p-baum]', b);
      baum.style.height = bh + 'px'; baum.style.width = Math.round(bh * 0.8) + 'px'; baum.style.bottom = boden + 'px'; baum.style.left = baumX + 'px';
      var ms = $('[data-p-mass]', b); ms.style.bottom = (boden + bh - 8) + 'px'; ms.style.left = Math.min(W - 90, baumX + Math.round(bh * 0.33)) + 'px'; ms.textContent = cm + ' cm';
      var ab = $('[data-p-abstand]', b), luft = st.decke - cm;
      ab.style.bottom = (boden + bh) + 'px'; ab.style.height = Math.max(0, Math.round(luft * px)) + 'px'; ab.style.left = (baumX - 7) + 'px';
      $('[data-p-abstand-text]', b).textContent = luft + ' cm Luft';
      ab.hidden = luft * px < 18;
      podium.dataset.licht = st.licht ? 'true' : 'false';
      if (v) bildZeigen(v.bild, daten[st.linie].name + ', ' + cm + ' cm' + (st.licht ? ', mit LED-Beleuchtung' : ''));
    }
    regler.addEventListener('input', function () { st.decke = parseInt(regler.value, 10); zeichnen(); });
    $$('[data-linie]', b).forEach(function (r) { r.addEventListener('change', function () { st.linie = parseInt(r.value, 10); zeichnen(); }); });
    schalter.addEventListener('click', function () { st.licht = !st.licht; schalter.setAttribute('aria-checked', st.licht ? 'true' : 'false'); zeichnen(); });
    window.addEventListener('resize', zeichnen);
    // Bilder vorladen, nachdem die Seite steht
    window.addEventListener('load', function () { daten.forEach(function (p) { p.varianten.forEach(function (v) { if (v.bild) { var i = new Image(); i.src = v.bild; } }); }); });
    zeichnen();
    b.dataset.bereit = 'true';
  });

  /* ---------- Produktseite ---------- */
  $$('[data-produkt]').forEach(function (p) {
    var daten; try { daten = JSON.parse($('[data-produkt-daten]', p).textContent); } catch (e) { return; }
    var V = daten.varianten, M = daten.medien;
    var o1 = Array.from(new Set(V.map(function (v) { return v.o1; }))), o2 = Array.from(new Set(V.map(function (v) { return v.o2; })));
    var url = new URL(location.href), start = parseInt(url.searchParams.get('variant') || '0', 10);
    var akt = V.filter(function (v) { return v.id === start; })[0] || V.filter(function (v) { return v.id === daten.start; })[0] || V[0];
    var st = { o1: akt.o1, o2: akt.o2, bild: 0, menge: 1, decke: null };
    var haupt = $('[data-g-haupt]', p), daumen = $('[data-g-daumen]', p), zaehlerG = $('[data-g-zaehler]', p), hinweisG = $('[data-g-hinweis]', p);
    function aktuell() { return V.filter(function (v) { return v.o1 === st.o1 && v.o2 === st.o2; })[0]; }
    function medienFuer(v) {
      var key = ', ' + v.o1 + ', ' + v.o2 + ' –';
      var l = [], ersatz = false;
      var eigen = M.filter(function (m) { return m.id === v.bild; })[0];
      if (eigen) l.push(eigen);
      M.forEach(function (m) { if (m.alt.indexOf(key) > -1 && l.indexOf(m) < 0) l.push(m); });
      if (l.length < 2) {
        var k2 = ', ' + v.o1 + ', ';
        M.forEach(function (m) { if (m.alt.indexOf(k2) > -1 && l.indexOf(m) < 0) { l.push(Object.assign({ ersatz: true }, m)); ersatz = true; } });
      }
      if (!l.length) l = M.slice(0, 1);
      return { liste: l, ersatz: ersatz };
    }
    function galerie() {
      var v = aktuell(), g = medienFuer(v), l = g.liste;
      if (st.bild >= l.length) st.bild = 0;
      var m = l[st.bild];
      haupt.src = m.gross; haupt.srcset = m.srcset; haupt.alt = m.alt;
      zaehlerG.textContent = (st.bild + 1) + ' / ' + l.length;
      hinweisG.hidden = !m.ersatz;
      daumen.innerHTML = '';
      l.forEach(function (x, i) {
        var bt = document.createElement('button'); bt.type = 'button'; bt.className = 'pl-daumen'; bt.setAttribute('aria-label', T('bild', 'Bild ') + (i + 1) + T('von', ' von ') + l.length + T('zeigen', ' zeigen'));
        if (i === st.bild) bt.setAttribute('aria-current', 'true');
        bt.innerHTML = '<img alt="" loading="lazy" width="76" height="76" src="' + x.klein + '">';
        bt.addEventListener('click', function () { st.bild = i; galerie(); });
        daumen.appendChild(bt);
      });
    }
    $('[data-g-zurueck]', p) && $('[data-g-zurueck]', p).addEventListener('click', function () { var n = medienFuer(aktuell()).liste.length; st.bild = (st.bild - 1 + n) % n; galerie(); });
    $('[data-g-vor]', p) && $('[data-g-vor]', p).addEventListener('click', function () { var n = medienFuer(aktuell()).liste.length; st.bild = (st.bild + 1) % n; galerie(); });
    // Wischen auf dem Hauptbild
    (function () { var x0 = null; haupt.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true }); haupt.addEventListener('touchend', function (e) { if (x0 === null) return; var dx = e.changedTouches[0].clientX - x0; x0 = null; if (Math.abs(dx) < 40) return; var n = medienFuer(aktuell()).liste.length; st.bild = (st.bild + (dx < 0 ? 1 : -1) + n) % n; galerie(); }); })();

    // Zoom-Ansicht: Klick oder Doppeltipp vergrößert, zwei Finger zoomen, Wischen verschiebt
    (function () {
      var dlg = $('[data-zoom]', p); if (!dlg || !dlg.showModal) return;
      var buehne = $('[data-zoom-buehne]', dlg), bild = $('[data-zoom-bild]', dlg), zZ = $('[data-zoom-zaehler]', dlg);
      var stufe = 1, MAX = 4, pinch = null, letzterTipp = 0;
      function liste() { return medienFuer(aktuell()).liste; }
      function grund() { var r = buehne.getBoundingClientRect(), nw = bild.naturalWidth || 1, nh = bild.naturalHeight || 1; return Math.min(r.width / nw, r.height / nh) * nw; }
      function setzen(neu, px, py) {
        var r = buehne.getBoundingClientRect(); px = px == null ? r.width / 2 : px; py = py == null ? r.height / 2 : py;
        var alt = bild.getBoundingClientRect(), relX = (px + r.left - alt.left) / alt.width, relY = (py + r.top - alt.top) / alt.height;
        stufe = Math.max(1, Math.min(MAX, neu));
        dlg.dataset.gezoomt = stufe > 1.01 ? 'true' : 'false';
        bild.style.width = Math.round(grund() * stufe) + 'px';
        var b = bild.getBoundingClientRect();
        buehne.scrollLeft += (b.left + relX * b.width) - (r.left + px);
        buehne.scrollTop += (b.top + relY * b.height) - (r.top + py);
      }
      function zeigen() {
        var l = liste(), m = l[st.bild] || l[0];
        bild.onload = function () { stufe = 1; dlg.dataset.gezoomt = 'false'; bild.style.width = Math.round(grund()) + 'px'; buehne.scrollTo(0, 0); };
        bild.src = m.zoom || m.gross; bild.alt = m.alt || '';
        zZ.textContent = (st.bild + 1) + ' / ' + l.length;
      }
      function blaettern(n) { var l = liste().length; st.bild = (st.bild + n + l) % l; galerie(); zeigen(); }
      function auf() { zeigen(); dlg.showModal(); document.documentElement.dataset.zoomOffen = 'true'; }
      $$('[data-zoom-auf]', p).forEach(function (b) { b.addEventListener('click', auf); });
      haupt.addEventListener('click', auf); haupt.style.cursor = 'zoom-in';
      dlg.addEventListener('close', function () { document.documentElement.dataset.zoomOffen = ''; var k = $('[data-zoom-auf]', p); k && k.focus(); });
      $('[data-zoom-zu]', dlg).addEventListener('click', function () { dlg.close(); });
      $('[data-zoom-zurueck]', dlg).addEventListener('click', function () { blaettern(-1); });
      $('[data-zoom-vor]', dlg).addEventListener('click', function () { blaettern(1); });
      dlg.addEventListener('keydown', function (e) { if (e.key === 'ArrowRight') blaettern(1); if (e.key === 'ArrowLeft') blaettern(-1); if (e.key === 'Escape') { e.preventDefault(); dlg.close(); } });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && dlg.open) dlg.close(); }, true);
      window.addEventListener('resize', function () { if (dlg.open) setzen(stufe); });
      bild.addEventListener('click', function (e) {
        if (e.pointerType === 'touch' || Date.now() - letzterTipp < 700) return;
        var r = buehne.getBoundingClientRect(); setzen(stufe > 1.01 ? 1 : 2.5, e.clientX - r.left, e.clientY - r.top);
      });
      buehne.addEventListener('touchstart', function (e) {
        if (e.touches.length === 2) { var a = e.touches[0], b = e.touches[1]; pinch = { d: Math.hypot(a.clientX - b.clientX, a.clientY - b.clientY), s: stufe }; }
      }, { passive: true });
      buehne.addEventListener('touchmove', function (e) {
        if (e.touches.length !== 2 || !pinch) return; e.preventDefault();
        var a = e.touches[0], b = e.touches[1], r = buehne.getBoundingClientRect();
        setzen(pinch.s * Math.hypot(a.clientX - b.clientX, a.clientY - b.clientY) / pinch.d, (a.clientX + b.clientX) / 2 - r.left, (a.clientY + b.clientY) / 2 - r.top);
      }, { passive: false });
      buehne.addEventListener('touchend', function (e) {
        if (pinch && e.touches.length < 2) { pinch = null; letzterTipp = Date.now(); return; }
        if (e.changedTouches.length !== 1 || e.touches.length) return;
        var t = e.changedTouches[0], jetzt = Date.now();
        if (jetzt - letzterTipp < 300) { var r = buehne.getBoundingClientRect(); setzen(stufe > 1.01 ? 1 : 2.5, t.clientX - r.left, t.clientY - r.top); letzterTipp = 0; e.preventDefault(); }
        else letzterTipp = jetzt;
      });
      dlg.addEventListener('click', function (e) { if (e.target === dlg) dlg.close(); });
    })();

    var hoehenBox = $('[data-hoehen]', p), seg = $('[data-o2]', p);
    var maxCm = Math.max.apply(null, o1.map(function (x) { return parseFloat(String(x).replace(',', '.')); }));
    function zahl(x) { return parseFloat(String(x).replace(',', '.')); }
    function wahl() {
      var v = aktuell();
      // Höhen / Größen
      $$('[data-o1-wert]', p).forEach(function (bt) {
        var sel = bt.dataset.o1Wert === st.o1;
        bt.setAttribute('aria-checked', sel ? 'true' : 'false');
        bt.tabIndex = sel ? 0 : -1;
        var zu = st.decke && daten.baum ? (zahl(bt.dataset.o1Wert) > st.decke - 20) : false;
        bt.dataset.zuhoch = zu ? 'true' : 'false';
        var vv = V.filter(function (x) { return x.o1 === bt.dataset.o1Wert && x.o2 === st.o2; })[0];
        var bi = $('[data-hoehe-bild]', bt), pr = $('[data-hoehe-preis]', bt);
        if (vv && bi && vv.frei && bi.getAttribute('src') !== vv.frei) bi.src = vv.frei;
        var zs = $('[data-hoehe-zusatz]', bt); if (zs) zs.textContent = vv && vv.hinweis ? vv.hinweis : zs.textContent;
        if (vv && pr) pr.textContent = geld(vv.preis);
        bt.setAttribute('aria-label', bt.dataset.o1Wert + (vv && vv.hinweis ? T('lieferung_aria', ', Lieferung ') + vv.hinweis : '') + (vv ? ', ' + geld(vv.preis) : '') + (zu ? T('zu_hoch_aria', ', zu hoch für Ihre Raumhöhe') : ''));
      });
      $$('[data-o2-wert]', p).forEach(function (bt) {
        var sel = bt.dataset.o2Wert === st.o2; bt.setAttribute('aria-checked', sel ? 'true' : 'false'); bt.tabIndex = sel ? 0 : -1;
        var gegen = V.filter(function (x) { return x.o1 === st.o1 && x.o2 === bt.dataset.o2Wert; })[0];
        var sp = $('span', bt); if (gegen && sp) sp.textContent = geld(gegen.preis);
        bt.dataset.keinBild = 'false';
      });
      var gewaehlt = $('[data-o1-anzeige]', p); if (gewaehlt) gewaehlt.textContent = st.o1;
      var g2 = $('[data-o2-anzeige]', p); if (g2) g2.textContent = st.o2;
      $('[data-preis-wert]', p).textContent = geld(v.preis);
      var u = $('[data-preis-uvp]', p); u.hidden = !(v.uvp > v.preis); u.innerHTML = v.uvp > v.preis ? T('uvp_s', 'UVP <s>') + geld(v.uvp) + '</s>' : '';
      // Fakten
      var f = $('[data-fakten]', p);
      if (f) {
        var rows = [];
        if (daten.baum) rows.push([T('hoehe', 'Höhe'), v.o1]);
        else rows.push([daten.groesse_name || T('groesse', 'Größe'), v.o1]);
        if (v.hinweis) rows.push([T('lieferung', 'Lieferung'), v.hinweis]);
        if (v.durchmesser) rows.push([T('oe_unten', 'Ø unten'), v.durchmesser + ' cm']);
        if (v.spitzen) rows.push([T('spitzen', 'Spitzen'), v.spitzen.toLocaleString('de-DE')]);
        // Runde 8: LEDs und Gewicht der 10-m-Girlande sind ungeklärt (2 × 5 m gegen Lieferantenwerte), deshalb nicht anzeigen
        if (v.leds && !v.offen) rows.push([T('leds', 'LEDs'), v.leds.toLocaleString('de-DE')]);
        if (v.gewicht && !v.offen) rows.push([T('gewicht', 'Gewicht'), String(v.gewicht).replace('.', ',') + ' kg']);
        f.dataset.anzahl = rows.length;
        f.innerHTML = rows.map(function (r) { return '<div><dt>' + r[0] + '</dt><dd class="pl-ziffern">' + r[1] + '</dd></div>'; }).join('');
      }
      var knopf = $('[data-kaufen]', p), meld = $('[data-meldung]', p);
      knopf.disabled = !v.verfuegbar; knopf.textContent = v.verfuegbar ? T('in_den_warenkorb', 'In den Warenkorb') : T('derzeit_ausverkauft', 'Derzeit ausverkauft');
      meld.dataset.sichtbar = 'false';
      $('[data-variante-id]', p).value = v.id;
      var leiste = $('[data-leiste-preis]'); if (leiste) leiste.textContent = geld(v.preis);
      var leisteT = $('[data-leiste-titel]'); if (leisteT) leisteT.textContent = st.o1 + ' · ' + st.o2.replace('Mit LED-Beleuchtung', 'mit LED-Licht').replace('Ohne Beleuchtung', 'ohne Licht');
      var leisteB = $('[data-leiste-bild]'); if (leisteB && v.frei) leisteB.src = v.frei;
      var leisteK = $('[data-leiste-kaufen]'); if (leisteK) { leisteK.disabled = !v.verfuegbar; leisteK.textContent = v.verfuegbar ? T('in_den_warenkorb', 'In den Warenkorb') : T('ausverkauft', 'Ausverkauft'); }
      if (history.replaceState) { url.searchParams.set('variant', v.id); history.replaceState(null, '', url.toString()); }
      galerie();
    }
    function radioTasten(gruppe, attr, setz) {
      gruppe && gruppe.addEventListener('keydown', function (e) {
        var bts = $$('[' + attr + ']', gruppe), i = bts.indexOf(document.activeElement);
        if (i < 0) return;
        var n = e.key === 'ArrowRight' || e.key === 'ArrowDown' ? 1 : e.key === 'ArrowLeft' || e.key === 'ArrowUp' ? -1 : 0;
        if (!n) return; e.preventDefault(); var k = bts[(i + n + bts.length) % bts.length]; setz(k); k.focus();
      });
    }
    $$('[data-o1-wert]', p).forEach(function (bt) { bt.addEventListener('click', function () { st.o1 = bt.dataset.o1Wert; st.bild = 0; wahl(); }); });
    $$('[data-o2-wert]', p).forEach(function (bt) { bt.addEventListener('click', function () { st.o2 = bt.dataset.o2Wert; st.bild = 0; wahl(); }); });
    radioTasten(hoehenBox, 'data-o1-wert', function (k) { st.o1 = k.dataset.o1Wert; st.bild = 0; wahl(); });
    radioTasten(seg, 'data-o2-wert', function (k) { st.o2 = k.dataset.o2Wert; st.bild = 0; wahl(); });
    var deckeIn = $('[data-p-decke-ein]', p), deckeOut = $('[data-p-decke-aus]', p);
    deckeIn && deckeIn.addEventListener('input', function () {
      var d = parseInt(deckeIn.value, 10);
      if (!d || d < 150 || d > 500) { st.decke = null; deckeOut.textContent = ''; wahl(); return; }
      st.decke = d;
      var passt = o1.filter(function (x) { return zahl(x) <= d - 20; });
      if (passt.length) { var best = passt[passt.length - 1]; deckeOut.textContent = T('passt_bis', 'Passt bis ') + best + '.'; if (zahl(st.o1) > d - 20) { st.o1 = best; } }
      else deckeOut.textContent = T('zu_hoch_alle', 'Für diese Raumhöhe ist jeder Baum zu hoch.');
      wahl();
    });
    // Menge
    var mIn = $('[data-menge]', p);
    $('[data-menge-minus]', p).addEventListener('click', function () { mIn.value = Math.max(1, (parseInt(mIn.value, 10) || 1) - 1); });
    $('[data-menge-plus]', p).addEventListener('click', function () { mIn.value = Math.min(20, (parseInt(mIn.value, 10) || 1) + 1); });
    // Kaufen
    var form = $('[data-kaufform]', p);
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var knopf = $('[data-kaufen]', p), meld = $('[data-meldung]', p), v = aktuell();
      knopf.disabled = true; knopf.textContent = T('wird_hinzugefuegt', 'Wird hinzugefügt …');
      Korb.hinzu(v.id, parseInt(mIn.value, 10) || 1).then(function () { return Korb.laden(); }).then(function (c) {
        knopf.disabled = false; knopf.textContent = T('in_den_warenkorb', 'In den Warenkorb'); Korb.zeichnen(c); Korb.oeffnen();
      }).catch(function (err) { knopf.disabled = false; knopf.textContent = T('in_den_warenkorb', 'In den Warenkorb'); meld.textContent = T('fehler_text', 'Das hat nicht geklappt: ') + err.message + T('bitte_erneut', ' Bitte versuchen Sie es noch einmal.'); meld.dataset.sichtbar = 'true'; });
    });
    var leisteKnopf = $('[data-leiste-kaufen]');
    leisteKnopf && leisteKnopf.addEventListener('click', function () { form.requestSubmit ? form.requestSubmit() : form.dispatchEvent(new Event('submit', { cancelable: true })); });
    // Mobile Kaufleiste, sobald der Hauptknopf aus dem Bild ist
    var leiste = $('[data-leiste]');
    if (leiste) {
      // Leiste zeigen, sobald der Kaufknopf oben aus dem Bild gescrollt ist (Scroll-Messung statt IntersectionObserver: feuert zuverlässig, auch nach Sprüngen)
      var kaufKnopf = $('[data-kaufen]', p), geplant = false;
      var leistePruefen = function () { geplant = false; var an = kaufKnopf.getBoundingClientRect().bottom < 0 ? 'true' : 'false'; if (leiste.dataset.sichtbar !== an) { leiste.dataset.sichtbar = an; document.body.dataset.leisteOffen = an; } };
      var leisteTakt = function () { if (!geplant) { geplant = true; requestAnimationFrame(leistePruefen); } };
      window.addEventListener('scroll', leisteTakt, { passive: true }); window.addEventListener('resize', leisteTakt); leistePruefen();
    }
    wahl();
    p.dataset.bereit = 'true';
  });

  /* ---------- Sortiment ---------- */
  $$('[data-sortiment]').forEach(function (s) {
    var karten = $$('[data-karte]', s), raster = $('[data-raster]', s), anzahl = $('[data-anzahl]', s);
    var f = {};
    function filtern() {
      var n = 0;
      karten.forEach(function (k) {
        var ok = Object.keys(f).every(function (g) { return !f[g] || k.dataset[g] === f[g]; });
        k.hidden = !ok; if (ok) n++;
      });
      raster.dataset.leer = n ? 'false' : 'true';
      if (anzahl) anzahl.textContent = n === 1 ? T('eine_ausfuehrung', '1 Ausführung') : n + T('ausfuehrungen', ' Ausführungen');
    }
    $$('[data-filter]', s).forEach(function (bt) {
      bt.addEventListener('click', function () {
        var g = bt.dataset.filter, w = bt.dataset.wert;
        f[g] = w || '';
        $$('[data-filter="' + g + '"]', s).forEach(function (x) { x.setAttribute('aria-pressed', x === bt ? 'true' : 'false'); });
        filtern();
      });
    });
    filtern();
    s.dataset.bereit = 'true';
  });

  window.__plBereit = true;
})();
